class UrlResolver {
  private _localDomain = 'https://milwaukee.local';

  /**
   *
   * Resolves the given relative URL
   */
  public resolveRelativeUrl = (url: string): string => {
    const slugSeparator = url.startsWith('/') ? '' : '/';
    const domain = this.getDomain();

    if (domain) {
      return `${domain}${slugSeparator}${url}`;
    }

    return url;
  };

  /**
   *
   * Gets the current domain
   */
  public getDomain = (): string => {
    if (`${process.env.NODE_ENV}`.toLowerCase() === 'development') {
      return this._localDomain;
    }

    return '';
  };

  public formatImageUrl = (baseImageUrl: string, width: number, height?: number): string => {
    if (baseImageUrl === undefined || baseImageUrl === null) {
      return baseImageUrl;
    }

    if (width) {
      const questionMarks = (baseImageUrl.match(/\?/g) || []).length;

      if (questionMarks === 0) {
        if (height !== undefined) {
          return `${baseImageUrl}?width=${width}&height=${height}`;
        }
        return `${baseImageUrl}?width=${width}`;
      }

      if (height !== undefined) {
        return `${baseImageUrl}&width=${width}&height=${height}`;
      }
      return `${baseImageUrl}&width=${width}`;
    }

    return baseImageUrl;
  };
}

export default new UrlResolver();
